import React, { Component } from 'react';
import { hashHistory } from 'react-router'
import Icon from './../Icon';
import styles from './back-link.scss';
import CSSModules from 'react-css-modules'
import localize from '../../../localize'
import { getCurrentLanguage } from '../../../localData';

class BackLink extends Component {
    constructor(props, context) {
        super(props, context);
    }

    handleClick() {
        if (!!this.props.url) {
            hashHistory.push(this.props.url);
        } else {
            this.context.router.goBack()
        }
    }

    render() {
        function l(key) {
            const str = `${getCurrentLanguage()}.components.BackLink.${key}`;
            return localize(str);
        }

        return (
            <button styleName="button-back" onClick={ () => this.handleClick() }>
                <Icon styleName="icon-prev" icon="Vitra_Previous.svg" />
            </button>
        )
    }
}

BackLink.contextTypes = {
    router: React.PropTypes.object.isRequired
};

export default CSSModules(BackLink, styles);


// WEBPACK FOOTER //
// ./app/components/shared/BackLink/index.jsx